<script setup>
import { useVModel } from '@vueuse/core';
import { computed } from 'vue';

const SIMBOLOS = {
  precio: 'euro-sign',
  porcentaje: 'percent',
};

const props = defineProps({
  modelValue: { type: Number, default: null },
  name: { type: String, default: undefined },
  nameTipo: { type: String, default: undefined },
  hiddenInputs: { type: Boolean, default: false },
  // Hash para usar otros valores según el tipo ej: { precio: 'fixed', porcentaje: 'percentage' }
  tiposValores: { type: Object, default: undefined },
});
const emits = defineEmits(['update:modelValue', 'update:tipo']);

// const [model, modelModifiers] = defineModel({ type: Number, default: undefined });
const tipo = defineModel('tipo', { type: String, default: 'precio' });

// passive para relance todo al v-model original
const model = useVModel(props, 'modelValue', emits, { passive: true });

const tipoMapeado = computed(() => (
  props.tiposValores ? props.tiposValores[tipo.value] : tipo.value
));

function cambiarTipo() {
  tipo.value = tipo.value === 'precio' ? 'porcentaje' : 'precio';
}

function setValor(valorTipo, cantidad) {
  model.value = cantidad ? Number.parseFloat(cantidad) : undefined;
  tipo.value = valorTipo === 'percentage' ? 'porcentaje' : 'precio';
}

// Desde suscripciones cambian el valor de este componente lanzado un evento
// que escuchamos aquí. Es un componente Marionette, de momento hay que hacer
// esta cochinada, luego habrá que quitarlo cuando proceda
function actualizar(evento) {
  setValor(evento.detail.tipo, evento.detail.cantidad);
}

defineExpose({ setValor });
</script>

<template>
  <div class="input-group input-precio-porcentaje" @actualizar="actualizar($event)">
    <span class="input-group-btn">
      <button type="button" class="btn btn-default" @click="cambiarTipo">
        <i :class="`fa fa-fw fa-${SIMBOLOS[tipo]}`"></i>
        <i class="fa fa-sort"></i>
      </button>
    </span>
    <InputNumerico
      v-model="model"
      v-model:tipo="tipo"
      :name="name"
      :configuracion="tipo"
    />
    <input
      v-if="hiddenInputs"
      type="hidden"
      :name="name"
      :value="model"
    >
    <input
      v-if="hiddenInputs"
      type="hidden"
      :name="nameTipo"
      :value="tipoMapeado"
    >
  </div>
</template>
<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";

</style>
